import React from "react";
import PropTypes from "prop-types"

// Importando PropTypes

const ColComponent = (props) => {
  if(props.hide){
    return <React.Fragment />
  }
  return (
    <div
      className={`col-${props.col} col-md-${props.md} col-lg-${props.lg} col-xl-${props.xl} col-xs-${props.xs} ${props.className}`}
    >
      {props.children}
    </div>
  );
};
const columnOptions = Array.from({ length: 12 }, (_, i) => (i + 1).toString());

ColComponent.propTypes = {
  col: PropTypes.oneOf(columnOptions),  // 'col' deve estar dentro das opções definidas
  md: PropTypes.oneOf(columnOptions),   // 'md' deve estar dentro das opções definidas
  lg: PropTypes.oneOf(columnOptions),   // 'lg' deve estar dentro das opções definidas
  xs: PropTypes.oneOf(columnOptions),   // 'xs' deve estar dentro das opções definidas
  children: PropTypes.node               // 'children' pode ser qualquer coisa renderizável
};

export default ColComponent;


// WEBPACK FOOTER //
// ./src/_components/Layout/Column/index.jsx